import { StatusBadge } from '@/components/common/StatusBadge';
import { BATCH_STAGE_LABEL, BATCH_STAGE_TONE } from '@/constants/batchStages';

interface BatchStageBadgeProps {
  stage: string;
  stageLabels?: Record<string, string> | undefined;
}

export function BatchStageBadge({ stage, stageLabels = BATCH_STAGE_LABEL }: BatchStageBadgeProps) {
  return (
    <StatusBadge tone={BATCH_STAGE_TONE[stage] ?? 'neutral'}>
      {stageLabels[stage] ?? stage}
    </StatusBadge>
  );
}
